import { createZodFormResolver, lt, showSuccessAlert } from '@mews/framework';
import { CommanderFormProps, useDialogFormControls } from '@mews-commander/form';
import { AccountType, ServiceOrderNoteType } from '@mews-commander/data-access';
import { WithReservationId } from '@mews-commander/types';
import { FormValues, schema } from '../schema';
import { useAddReservationNote } from './useAddReservationNote';
import { useAddAccountNote } from './useAddAccountNote';

const resolver = createZodFormResolver(schema);
interface UseAddNoteFormControlsProps extends CommanderFormProps, WithReservationId {
    defaultValues: FormValues;
}

export const useAddNoteFormControls = ({
    defaultValues,
    reservationId,
    onSubmitting,
    onSuccess,
    onSubmitted,
    ...formProps
}: UseAddNoteFormControlsProps) => {
    const onSuccessHandler = () => {
        showSuccessAlert({ description: lt('GuestInHouseReportAddNoteSuccessMessage') });
        onSuccess?.();
    };
    const { mutate: addReservationNote } = useAddReservationNote({
        onSuccess: onSuccessHandler,
        onSettled: onSubmitted,
    });
    const { mutate: addAccountNote } = useAddAccountNote({ onSuccess: onSuccessHandler, onSettled: onSubmitted });

    const handleSubmit = (values: FormValues) => {
        onSubmitting?.();
        if (values.noteType === 'reservation') {
            addReservationNote({
                text: values.text,
                reservationIds: [reservationId],
                type: ServiceOrderNoteType.General,
            });
        } else {
            addAccountNote({
                accountId: values.accountId,
                data: {
                    discriminator: AccountType.Customer,
                    value: {
                        classifications: [values.classification],
                    },
                },
                content: values.content,
            });
        }
    };

    const { renderFormContent, watch } = useDialogFormControls<FormValues>({
        ...formProps,
        resolver,
        defaultValues,
        onSubmit: handleSubmit,
    });

    return { renderFormContent, watch };
};
